import React from 'react';
import * as THREE from 'three';
import './ThreeDBlock.css';

export default class ThreeDBlock extends React.Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
  }

  componentDidMount() {
    const scene = new THREE.Scene();
    scene.background = new THREE.Color("rgb(243, 234, 222)");
    scene.fog=new THREE.FogExp2("white", 0.3);
    const camera = this.SetUpCamera();
    const renderer = this.SetUpRenderer();

    const cube = this.SetUpBlock();

    scene.add(cube);
    camera.position.z = 4;

    function animate() {
      requestAnimationFrame( animate );
      renderer.render( scene, camera );

      cube.rotation.x += 0.01;
      cube.rotation.y += 0.01;
      cube.rotation.z += 0.01;
    }
    animate();
  }

  SetUpCamera() {  
    const camera = new THREE.PerspectiveCamera(75,
      window.innerWidth / window.innerHeight);

    return camera;
  }

  SetUpRenderer() {
    const renderer = new THREE.WebGL1Renderer();
    renderer.setSize(window.innerWidth,window.innerHeight);
    this.container.current.appendChild(renderer.domElement);

    return renderer;
  }

  SetUpBlock() {
    const geometry = new THREE.BoxGeometry();
    const material = new THREE.MeshToonMaterial({color:"white"});
    const cube = new THREE.Mesh( geometry, material );
    
    return cube;
  }

  render() {
    return (
      <>
        <h5>3D Block</h5>
        <div 
          className="threeDBlock-content"
          ref={this.container}
        >

        </div>
      </>)
  }
}